export const LivechatConversationStateList = {
  main: { id: 0, name: 'Main', sortOrder: 0 },
  follow_up: { id: 1, name: 'Follow Up', sortOrder: 1 },
  pending: { id: 2, name: 'Pending', sortOrder: 2 },
  resolved: { id: 3, name: 'Resolved', sortOrder: 3 },
  done: { id: 4, name: 'Done', sortOrder: 4 },
};
export type LivechatConversationState =
  keyof typeof LivechatConversationStateList;
export type LivechatConversationStateOption = {
  id: number;
  kind: LivechatConversationState;
  name: string;
};
export const LivechatConversationStateOptions = (
  Object.keys(LivechatConversationStateList) as LivechatConversationState[]
)
  .sort(
    (a, b) =>
      LivechatConversationStateList[a].sortOrder -
      LivechatConversationStateList[b].sortOrder,
  )
  .map(
    kind =>
      ({
        ...LivechatConversationStateList[kind],
        kind,
      } as LivechatConversationStateOption),
  );
